<template>
  <div>
    <logged-in-bar></logged-in-bar>
    <h1>Renters Insurance by National Student Services, Inc. (NSSI)</h1>
    <table
      width="100%"
      height="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
    >
      <tbody>
        <tr>
          <td height="100">
            <div style="text-align: center">
              <my-logo></my-logo>
            </div>
          </td>
        </tr>
        <tr>
          <td height="80%">
            <section class="quotewizard">
              <div class="container">
                <br /><br />
                <div class="title" style="text-align: center">
                  Assurant Legal
                </div>
                <br />
                <center>
                  <a href="#" onclick="window.history.back();"
                    >❮&nbsp;&nbsp;Back</a
                  >
                </center>
                <br /><br />
                <div class="subtitle">Underwriters</div>
                <br />
                <p>
                  In all states, unless otherwise noted, Renters Insurance is
                  underwritten by American Bankers Insurance Company of Florida
                  with its home office in Miami, Florida. In Minnesota, the
                  underwriter is American Security Insurance company. In
                  Georgia, Residents Liability is underwritten by Voyager
                  Indemnity Insurance Company. These companies operate under the
                  trade name Assurant.
                </p>
                <p>
                  In Utah, coverage is provided under policy form AJ8850PC-0307
                  or AJ9281CKK-0609.
                </p>
                <br /><br />
                <div class="subtitle">Underwriting Entities</div>
                <br />
                <p>
                  You are provided the following information pursuant to various
                  state insurance laws, including, but not limited to, those of
                  California, Massachusetts and Missouri. Each insurer has sole
                  financial responsibility for its own products.
                </p>
                <br /><br />
                <div class="scrolltable">
                  <table class="styledtable" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td><strong>Insurance Company</strong></td>
                        <td>
                          <strong
                            >National Association of Insurance Commissioners' ID
                            #</strong
                          >
                        </td>
                        <td>
                          <strong
                            >Jurisdictions in US Where Authorized to Do
                            Business</strong
                          >
                        </td>
                        <td><strong>State of Domicile&nbsp;</strong></td>
                      </tr>
                      <tr>
                        <td>
                          <strong
                            >American Bankers Insurance Company of
                            Florida</strong
                          ><br />11222 Quail Roost Drive<br />Miami, FL 33157<br /><span
                            >(305) 253-2244</span
                          >
                        </td>
                        <td>&nbsp;10111</td>
                        <td>&nbsp;All States &amp; the District of Columbia</td>
                        <td>&nbsp;Florida</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>American Security Insurance Company</strong
                          ><br />260 Interstate N Circle - SE<br />Atlanta, GA
                          30339 <br /><span>(770) 763-1000</span>
                        </td>
                        <td>&nbsp;42978</td>
                        <td>&nbsp;All States except NH</td>
                        <td>&nbsp;Delaware</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Voyager Indemnity Insurance Company</strong
                          ><br />260 Interstate N Circle - SE<br />Atlanta, GA
                          30339 <br /><span>(770) 763-1000</span>
                        </td>
                        <td>&nbsp;40428</td>
                        <td>&nbsp;Georgia</td>
                        <td>&nbsp;Georgia</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br /><br />
              </div>
            </section>
          </td>
        </tr>
        <tr>
          <td height="80">
            <div class="quote-footer" style="text-align: center">
              © {{ getCurrentYear }} National Student Services, Inc. All Rights
              Rights Reserved.<br />
              <a href="https://nssi.com/terms-of-use" target="_blank"
                >Terms of Use</a
              >
              &nbsp;|&nbsp;
              <a href="https://nssi.com/privacy-policy" target="_blank"
                >Privacy Policy</a
              >
              &nbsp;|&nbsp;
              <router-link :to="{ name: 'legalAssurant' }"
                >Assurant Legal</router-link
              >
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import LoggedInBar from "@/views/partials/LoggedInBar.vue";
import MyLogo from "@/views/partials/RentersLogo.vue";
import { removeNoScroll } from "@/utils/NoScroll";
import { onMounted } from "vue";
import { getCurrentYear } from "@/utils/Utils";

onMounted(() => {
  removeNoScroll();
  window.scrollTo(0, 0);
});
</script>
